import { ToolTip } from "@vernost_dev/vms-react-components/dist/ToolTip";
export const VmsToolTip = ({
  id,
  additionalClassName,
  children,
  title,
  position = "bottom",
  background = "#000",
  arrow = true,
  additionalStyle,
}) => {
  return (
    <ToolTip
      id={id}
      additionalClassName={additionalClassName}
      title={title}
      position={position}
      background={background}
      arrow={arrow}
      additionalStyle={additionalStyle}
    >
      {children}
    </ToolTip>
  );
};
